import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import {
  getHuddleEventEmptyState,
  HUDDLE_EVENTS_LIST_VISIBLE_ROWS,
} from '../huddleMockData'
import type { HuddleDashboard } from '../useHuddleDashboard'

type EventsCardProps = {
  events: HuddleDashboard['eventsApi']
  className?: string
}

export function EventsCard({
  events,
  className = 'dashboard-huddle-events-card',
}: EventsCardProps): React.ReactElement {
  const { columns, loading, data } = events
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    columns.some((column) => column.people.length > 0),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Events"
      showTitleChevron={false}
      className={className}
      loading={pending}
      skeleton={{ block: 'default' }}
      isEmpty={isEmpty}
    >
      <div className="dashboard-huddle-events-columns">
        {columns.map((column) => {
          const empty = getHuddleEventEmptyState(column.id)
          return (
            <div key={column.id} className="dashboard-huddle-events-column">
              <h6 className="dashboard-huddle-events-column-title">
                {column.leftLabel}
              </h6>
              {column.people.length > 0 ? (
                <div className="dashboard-huddle-events-column-body">
                  <p className="dashboard-huddle-events-count">
                    {column.people.length}
                  </p>
                  <div
                    className="dashboard-huddle-events-list"
                    style={
                      {
                        '--huddle-events-visible-rows':
                          HUDDLE_EVENTS_LIST_VISIBLE_ROWS,
                      } as React.CSSProperties
                    }
                  >
                    {column.people.map((person) => (
                      <div
                        key={person.id}
                        className="dashboard-huddle-events-list-item"
                      >
                        {person.name}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="dashboard-huddle-events-empty">
                  <p className="dashboard-huddle-events-empty-heading">
                    {empty.heading}
                  </p>
                  <p className="dashboard-huddle-events-empty-description">
                    {empty.description}
                  </p>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </DashboardSectionCard>
  )
}
